import { withStyles } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { withRouter } from "react-router-dom";
import { withPresenter } from "../../helpers/with-presenter";
import { Colofon } from "../content/components/colofon-slide";
import { DefaultIndexInfo } from "../content/index/default-index-info";
import { EditionIndexInfo } from "../content/index/edition-index-info";
import { MagazineIndexInfo } from "../content/index/magazine-index-info";
import { PageIndexPresenter } from "./index-presenter";
import LoadingAnimation from "./loading";

var styles = function styles(theme) {
  var _a, _b, _c, _d, _e;

  return {
    root: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      padding: "5vw",
      paddingBottom: "calc(5vw + " + theme.spacing(5) + "px)"
    },
    header: (_a = {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      paddingBottom: "5vw"
    }, _a[theme.breakpoints.down("sm")] = {
      marginTop: 20
    }, _a),
    content: {
      maxWidth: 1500,
      width: "100%"
    },
    grid: (_b = {}, _b[theme.breakpoints.down("sm")] = {
      flexDirection: "column",
      alignItems: "center"
    }, _b),
    paper: (_c = {
      width: "65vw",
      color: "white",
      // @Jordy Kommeren: "Fixes iOS scroll bug"
      // minHeight: "fit-content",
      height: "100vh",
      backgroundColor: "#E9550D",
      "::-webkit-scrollbar": {
        display: "none"
      }
    }, _c[theme.breakpoints.up("lg")] = {
      maxWidth: "1050px",
      padding: theme.spacing(5, 0)
    }, _c[theme.breakpoints.down("sm")] = {
      minWidth: "100vw"
    }, _c),
    montserrat: {
      fontFamily: "Montserrat",
      lineHeight: "1.3"
    },
    title: {
      fontWeight: 500
    },
    aboutButtons: {
      marginTop: theme.spacing(2),
      backgroundColor: "transparant"
    },
    button: {
      padding: theme.spacing(1, 0, 1, 0),
      minWidth: "unset !important",
      fontWeight: 400,
      "&:hover": {
        background: "none",
        color: theme.palette.primary.main
      }
    },
    closeButton: {
      padding: 10,
      borderRadius: "100%",
      border: "2px solid white",
      width: "50px !important",
      height: "50px !important",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: "white",
        color: "#E9550D"
      }
    },
    icon: {
      color: "inherit",
      width: "25px !important",
      height: "25px !important"
    },
    aboutHeader: (_d = {
      position: "absolute",
      top: theme.spacing(3),
      right: theme.spacing(3)
    }, _d[theme.breakpoints.up("lg")] = {
      top: theme.spacing(6),
      right: theme.spacing(6)
    }, _d),
    aboutContent: (_e = {
      display: "flex",
      alignItems: "center"
    }, _e[theme.breakpoints.up("lg")] = {
      padding: theme.spacing(3, 6, 6, 6)
    }, _e[theme.breakpoints.down("md")] = {
      padding: theme.spacing(6, 1, 18, 1)
    }, _e.minHeight = "100%", _e)
  };
};

var RenderIndexInfo = withStyles(styles)(function (_a) {
  var magazine = _a.magazine,
      edition = _a.edition,
      classes = _a.classes;
  var result;

  if (magazine) {
    if (edition) {
      result = React.createElement(EditionIndexInfo, {
        edition: edition
      });
    } else {
      result = React.createElement(MagazineIndexInfo, {
        magazine: magazine
      });
    }
  } else {
    result = React.createElement(DefaultIndexInfo, null);
  }

  return React.createElement("div", {
    className: classes.indexInfo
  }, result);
});
var Component = observer(function (_a) {
  var presenter = _a.presenter,
      classes = _a.classes,
      match = _a.match;

  var _b = React.useState({
    open: false,
    content: React.createElement(Colofon, null)
  }),
      state = _b[0],
      setState = _b[1];

  if (presenter.loading) {
    return React.createElement(LoadingAnimation, null);
  }

  return React.createElement(React.Fragment, null);
});
export var PageIndex = withStyles(styles)(withRouter(withPresenter(function (_a, _b) {
  var match = _a.match,
      history = _a.history,
      location = _a.location,
      staticContext = _a.staticContext;
  var interactor = _b.interactor,
      provider = _b.provider;
  return new PageIndexPresenter(interactor.magazine, provider.magazine, interactor.article, provider.article, {
    match: match,
    history: history,
    location: location,
    staticContext: staticContext
  });
}, Component)));